<div class="hero__container" [class.no-image]="!image?.url">
	<div class="hero__info" [class.no-image]="!image?.url">
		<edr-heading [level]="1" class="hero__info-title" [text]="title"></edr-heading>
		<div class="hero__info-description" [innerHTML]="description"></div>
		<ng-content />
	</div>
	<img *ngIf="image?.url" class="hero__image" [src]="image?.url" [alt]="image?.alt" />
</div>
